module.exports = __webpack_public_path__ + "img/chergpt2.1466caad.jpg";